<script setup>
import { defineOptions, onMounted, reactive } from 'vue';
import ProductItem from '@/components/front/product/ProductItem.vue';
import combinationStorage from '@/services/combination-storage';

defineOptions({
  name: 'ModalBodyProductItem'
});

onMounted(() => {
  loadItem();
});

const state = reactive({
  data: null
});

async function loadItem() {
  const connectorProductIds = []

  if (combinationStorage.initialItem && combinationStorage.terminalItem) {
    connectorProductIds.push(combinationStorage.initialItem.productId);
    connectorProductIds.push(combinationStorage.terminalItem.productId);
  }

  const res = await u.$http.get(
    '@combination_ajax/loadProductItem',
    {
      params: {
        id: combinationStorage.productId,
        connectorProductIds: connectorProductIds,
      }
    }
  );

  state.data = res.data.data;

  if (combinationStorage.modalType === 'initial') {
    state.data.currentVariant = combinationStorage.initialItem;
  }

  if (combinationStorage.modalType === 'terminal') {
    state.data.currentVariant = combinationStorage.terminalItem;
  }

  if (combinationStorage.modalType === 'cable') {
    state.data.currentVariant = combinationStorage.cables[combinationStorage.currentEditCable].variant;
  }
}

async function handleSelected(v) {
  await setValue(v);

  combinationStorage.modalState = false;
}

function setValue(v) {
  if (combinationStorage.modalType === 'initial') {
    combinationStorage.initialItem = v.item;
    combinationStorage.initialItem.product = state.data.product;
    combinationStorage.initialItem.mainVariant = state.data.mainVariant;
    combinationStorage.initialItem.mappingIds = state.data.mappingIds;
  }

  if (combinationStorage.modalType === 'terminal') {
    combinationStorage.terminalItem = v.item;
    combinationStorage.terminalItem.product = state.data.product;
    combinationStorage.terminalItem.mainVariant = state.data.mainVariant;
    combinationStorage.terminalItem.mappingIds = state.data.mappingIds;
  }

  if (combinationStorage.modalType === 'cable') {
    combinationStorage.cables[combinationStorage.currentEditCable].variant = v.item;
    combinationStorage.cables[combinationStorage.currentEditCable].variant.length = v.length;
    combinationStorage.cables[combinationStorage.currentEditCable].variant.product = state.data.product;
    combinationStorage.cables[combinationStorage.currentEditCable].variant.categories = state.data.mappingCategories;
  }
}
</script>

<template>
  <div v-if="state.data" class="modal-body pt-0">
    <nav v-if="combinationStorage.showBreadcrumb"
      aria-label="breadcrumb" class="c-breadcrumb-nav d-none d-md-block p-0">
      <div class="container-fluid p-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="javascript://" @click="combinationStorage.backToComponent('buttons')">
              產品分類
            </a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript://" @click="combinationStorage.goToCategoryList(state.data.parentCategory.path)">
              {{ state.data.parentCategory.title }}
            </a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript://" @click="combinationStorage.goToProductList(state.data.category.path)">
              {{ state.data.category.title }}
            </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ state.data.product.title }}
          </li>
        </ol>
      </div>
    </nav>

    <button class="c-prev btn d-md-none mb-3 border-0 px-3 w-100 text-start position-absolute top-0 start-0"
      @click="combinationStorage.goToCategoryList(state.data.category.path)">
      <i class="fa-regular fa-chevron-left me-2"></i>
      {{ state.data.category.title }}
    </button>

    <div class="l-product-item pt-1">
      <ProductItem :key="`product-` + state.data.product.id"
        type="combination"
        :subtype="combinationStorage.categoryType"
        :data="state.data"
        @combinationUpdate="handleSelected"
      ></ProductItem>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-primary {
  margin-top: 64px;
}
</style>
